import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CommunityBoardRegasyncReqPros, CommunityBoardRegInitialState } from "../model/CommunityBoardRegReducerType";

const reducerId = "CommunityBoardRegReducer/asyncReqCommunityBoardReg";
const controllerMap = new Map();

const initialState: CommunityBoardRegInitialState = {
    status: "",
    n4ErrorCode: 0,
    strErrorMessage: "",
    isSuccess: false
};

const slice = createSlice({
    name: "CommunityBoardRegReducer",
    initialState,
    reducers: {
        setInitStatus: (state) => {
            state.status = "";
        }
    },
    extraReducers: (builder) => {
        builder.addCase(asyncReqCommunityBoardReg.pending, (state) => {
            state.status = "LOADING";
        });
        builder.addCase(asyncReqCommunityBoardReg.fulfilled, (state, action) => {
            state.status = "COMPLETE";
            state.n4ErrorCode = action.payload.n4ErrorCode;
            state.strErrorMessage = action.payload.strErrorMessage;
            state.isSuccess = action.payload.isSuccess;
        });
        builder.addCase(asyncReqCommunityBoardReg.rejected, (state, action) => {
            if (action.payload?.aborted) return; // 'AbortError'로 인한 취소라면 상태 변경하지 않음
            state.status = "FAIL";
        });
    }
});

type RejectPayload = { aborted: boolean; message?: string };

export const asyncReqCommunityBoardReg = createAsyncThunk<
        any, // 성공 시 반환 타입 (API 응답 타입)
        CommunityBoardRegasyncReqPros, // thunk 파라미터 타입
        {
            rejectValue: RejectPayload; // ❗ rejectWithValue 타입 명시
        }
    >(
    reducerId,
    async ({ title, nickname, content, anonymous_yn, file }: CommunityBoardRegasyncReqPros, thunkAPI) => {
        // 이전 요청이 있으면 취소
        const prevController = controllerMap.get(reducerId);
        if (prevController) prevController.abort();

        // 새 요청용 controller 생성
        const controller = new AbortController();
        controllerMap.set(reducerId, controller);

        try {
            const formData = new FormData();
            formData.append("title", title);
            formData.append("nickname", nickname);
            formData.append("content", content);
            formData.append("anonymous_yn", anonymous_yn);
            if (file) {
                formData.append("image", file);
            }
            const res = await fetch(`${process.env.REACT_APP_API_DOMAIN}/ApiReact/CommunityBoardReg.aspx`,
                {
                    method: "POST",
                    body: formData,
                    signal: controller.signal
                }
            );
            const data = await res.json();
            return data;
        }
        catch (error: any) {
            // ❗ AbortError인 경우는 구분해서 처리
            if (error.name === "AbortError") {
                return thunkAPI.rejectWithValue({ aborted: true });
            }
            return thunkAPI.rejectWithValue({ aborted: false, message: error.message });
        }
    }
);

export const CommunityBoardRegActions = slice.actions;
export default slice.reducer;